import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getVehicleColor } from '../thunks/vehicleThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearVehicleKey } from '../thunkKeys/commonThunksKeys';

const SLICE_NAME = 'colorVehicle';

export const colorVehicleSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearColorVehicle(state) {
            state.data = [];
        },
    },

    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getVehicleColor });
        builder.addCase(
            clearVehicleKey,
            () => commonInitialState,
        );
    },
});

export const { clearColorVehicle } = colorVehicleSlice.actions;

export const colorVehicle = colorVehicleSlice.reducer;
